import React, { useState, useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import Select from '../../../../../../Form/Select';

import ServicerService from '../../../../../../../services/ServicerService';
import createServicerBankAccountsOptions from '../../../../../../../helpers/forms/createServicerBankAccountsOptions';

export default function BankAccountField({
  isPaymentVoid,
  isPaymentApplied,
  readOnly,
  updatePayment,
  payment,
}) {
  const [bankAccountId, setBankAccountId] = useState(null);

  const isServicerBankAccount = payment?.payer === 'Servicer';

  const { data: servicerBankAccounts } = useQuery({
    queryKey: ['servicerBankAccounts'],
    queryFn: ServicerService.getServicerBankAccounts,
    enabled: isServicerBankAccount,
  });

  const options = isServicerBankAccount
    ? createServicerBankAccountsOptions(servicerBankAccounts).map((account) => {
        return {
          value: account.id,
          label: account.option,
        };
      })
    : payment?._loan?._bank_accounts?.map((account) => ({
        value: account.id,
        label: `${account.account_number.replace(/.(?=.{4})/g, '* ')} ${
          account.id === payment?._loan?.bank_account_id ? ' (primary)' : ''
        }`,
      }));

  useEffect(() => {
    setBankAccountId(payment?.bank_account_id);
  }, [payment?.bank_account_id]);

  if (payment?.source !== 'ACH' || payment?.payer === 'Lender') {
    return null;
  }

  return (
    <Select
      readOnly={isPaymentVoid || isPaymentApplied || readOnly}
      label="Bank Account"
      value={bankAccountId}
      setFieldValue={(name, value) => {
        setBankAccountId(value);
        updatePayment({
          ...payment,
          bank_account_id: value,
        });
      }}
      options={options}
    />
  );
}
